import { decodeOffsetToken } from './utils/tokenUtils';

interface EnvConfig {
    envName: string;
    production: boolean;
    test: boolean;
    applicationName: string;
    defaultLanguage: string;
    baseURL: string | undefined;
    cryptoKey: string | undefined;
    octaClientId: string | undefined;
    viteAPIKey: string | undefined;
    viteAuthDomain: string | undefined;
    viteProjectId: string | undefined;
    viteStorageBucket: string | undefined;
    viteMessagingSenderId: string | undefined;
    viteAppId: string | undefined;
    viteMeasurementId: string | undefined;
}

const decodedToken = decodeOffsetToken(process.env.REACT_APP_API_AUTH_TOKEN || "");

export const env: EnvConfig = {
    envName: "DEV",
    production: false,
    test: false,
    applicationName: "upl",
    defaultLanguage: "en",
    baseURL: process.env.REACT_APP_API_BASE_URL,
    cryptoKey: decodedToken,
    octaClientId: process.env.REACT_APP_OKTA_CLIENT_ID,
    viteAPIKey: process.env.REACT_APP_VITE_FIREBASE_API_KEY,
    viteAuthDomain: process.env.REACT_APP_VITE_FIREBASE_AUTH_DOMAIN,
    viteProjectId: process.env.REACT_APP_VITE_FIREBASE_PROJECT_ID,
    viteStorageBucket: process.env.REACT_APP_VITE_FIREBASE_STORAGE_BUCKET,
    viteMessagingSenderId: process.env.REACT_APP_VITE_FIREBASE_MESSAGING_SENDER_ID,
    viteAppId: process.env.REACT_APP_VITE_FIREBASE_APP_ID,
    viteMeasurementId: process.env.REACT_APP_VITE_FIREBASE_MEASUREMENT_ID,
};